import React, { useState, useEffect } from 'react'
import "./About.scss"
import about from "../../Assets/Images/about.jpg"
import p1 from "../../Assets/Images/Products/Multivitamin Range.jpg"
import p2 from "../../Assets/Images/Products/Neuropathy Management.jpg"
import p3 from "../../Assets/Images/Products/Antidepressent Range.jpg"
import p4 from "../../Assets/Images/Products/Alzhiemer's Management  Anti Psychotic Range.jpg"
import p5 from "../../Assets/Images/Products/Anti Epileptic Range  Anti Migraine Range.jpg"
import p6 from "../../Assets/Images/Products/Anti-Vertigo Range.jpg"
import p7 from "../../Assets/Images/Products/PPI (Proton Pump Inhibitors) Range.jpg"
import slider from "../../Assets/Images/About/slider.png"
import slider2 from "../../Assets/Images/About/slider2.png"
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import sliderbg from "../../Assets/Images/3243.jpg"
import contact from "../../Assets/Images/contact.png"
import Slider from "react-slick";
import { Music, Guitar, Drum, Mic, Piano, ChevronLeft, ChevronRight } from "lucide-react";
import v1 from "../../Assets/Images/About/integrity.png"
import v2 from "../../Assets/Images/About/innovation.png"
import v3 from "../../Assets/Images/About/excellence.png"
import v4 from "../../Assets/Images/About/partnership.png"
import vision from "../../Assets/Images/About/vision.jpg"
import mission from "../../Assets/Images/About/mission.jpg"

const Home = () => {

     useEffect(() => {
        // 👇️ scroll to top on page load
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  
      }, []);

  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseMove = (e) => {
    const { left, top, width, height } = e.target.getBoundingClientRect();
    const x = e.clientX - left - width / 2; // Centering effect
    const y = e.clientY - top - height / 2;
    setPosition({ x, y });
  };
  // Card Data
  const cards = [
    { id: 1, title: "Integrity", description: "We conduct all our operations with honesty, transparency, and ethical responsibility.", icon: v1 },
    { id: 2, title: "Innovation", description: "We are committed to continuous scientific advancement and the development of cutting-edge solutions.", icon: v2 },
    { id: 3, title: "Excellence", description: " We strive for the highest standards of quality in all our products and services.", icon: v3 },
    { id: 4, title: "Partnership", description: "We believe in fostering strong, collaborative relationships with our clients and stakeholders.   ", icon: v4 },

  ];

  // Custom Arrow Components
  const CustomPrevArrow = (props) => (
    <button {...props} className="custom-arrow prev-arrow">
      <ChevronLeft size={30} />
    </button>
  );

  const CustomNextArrow = (props) => (
    <button {...props} className="custom-arrow next-arrow">
      <ChevronRight size={30} />
    </button>
  );
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    nextArrow: <CustomNextArrow />,
    prevArrow: <CustomPrevArrow />,
  };
  return (
    <div>
      <>


        <section className="about-page">

          <div className="about-text">
            <div className="section-title">
              <h3>About Us</h3>
            </div>
            <p>GSS Lifesciences was established in 2018 by Mr. Niraj Soni, with a vision to advance healthcare solutions in India. From our base in Gujarat, we are dedicated to providing high-quality pharmaceutical research and development. Our core mission is to improve patient outcomes through innovation and a commitment to excellence.</p>
            <p>  Since our inception, we have focused on building a strong foundation of scientific expertise and operational efficiency. Our goal is to become a leading provider of comprehensive life sciences solutions. Deal with <b style={{ color: "#e05e50" }}>WHO - GMP approved products</b> which show the highest quality of medicines.</p>
            <p> At GSS Lifesciences, we are driven by a set of core values that include integrity, innovation, excellence and partnership. We believe in fostering strong partnerships with our clients and stakeholders, working collaboratively to achieve mutual success. We are committed to upholding the highest ethical standards and maintaining transparency in all our operations.</p>
            <p> Our team, brings a wealth of experience and expertise to the pharmaceutical industry. We are dedicated to continuous improvement and staying at the forefront of scientific advancements.</p>
            <p> We are passionate about contributing to the advancement of healthcare and improving the lives of patients. GSS Lifesciences is poised to make a significant impact on the pharmaceutical landscape in India and Internationally.</p>
          </div>
          <img className='sliderimg' src={slider} alt="slider" />

        </section>

        <section className="about-mission ">
          <div className="img">
            <img src={mission} alt="mission" />

          </div>
          <div className="about-mission-card">
            <div className="section-title">
              <h3>Our Vision</h3>
            </div>
            {/* <h2> Our Vision</h2> */}
            {/* <p>To be a leading provider of comprehensive life sciences solutions, expanding our reach and impact across India and beyond, while continuously advancing healthcare through innovation and excellence.</p> */}

            <p>GSS Lifesciences envisions becoming a premier global force in life sciences, driven by innovation and unwavering commitment to quality. We strive to expand our reach, delivering comprehensive solutions that transform healthcare outcomes.</p><p> Our ambition is to pioneer advancements, ensuring accessibility to superior pharmaceutical products across India and internationally. By fostering strategic partnerships and upholding the highest ethical standards, we aim to consistently exceed expectations.</p><p> Our dedication to scientific excellence and patient well-being positions GSS Lifesciences as a trusted leader, shaping the future of healthcare through transformative solutions.</p>
          </div>

        </section>

        <section className="about-mission vision">
          <div className="img">
            <img src={vision} alt="vision" />

          </div>
          <div className="about-mission-card">
            <div className="section-title">
              <h3>Our Mission</h3>
            </div>
            {/* <h2> Our Vision</h2> */}
            <p>GSS Lifesciences focuses on improving patient health through the provision of high-quality pharmaceutical products. We achieve this through rigorous research, innovative development, and meticulous manufacturing, adhering to the highest quality standards.  </p>
            <p>Our mission is to foster enduring partnerships with clients and stakeholders, built on transparency and mutual respect. We are committed to ethical practices, ensuring integrity in every aspect of our operations.</p>
            <p>By embracing continuous improvement and scientific advancement, we strive to provide accessible, reliable, and impactful healthcare products, ultimately contributing to a healthier future for all.</p>
          </div>

        </section>


        <section className="about-values">
          <div className="section-title">
            {/* <h4>Our products</h4> */}
            <h3>Our Core Values</h3>
          </div>
          <div className="about-mission-card">
            {/* <div className="slider-container">
              <Slider {...settings}>
                {cards.map((card) => (
                  <div key={card.id} className="card">
                    <div className="icon">
                      <img src={card.icon} alt="" />
                    </div>

                    <h3>{card.title}</h3>
                    <p>{card.description}</p>
                  </div>
                ))}
              </Slider>
            </div> */}

            {cards.map((card) => (
              <div key={card.id} className="card">
                <div className="icon">
                  <img src={card.icon} alt={card.title} />
                </div>
                <div className="card-text">
                  <h3>{card.title}</h3>
                  <p>{card.description}</p>
                </div>

              </div>
            ))}
          </div>

        </section>
      </>

    </div>
  )
}

export default Home